export const DatabaseCollection = {
  PRESTIGE_CONFIGURATIONS: 'prestige-configurations',
  PRICING_CONFIGURATIONS: 'prestige-pricing-configurations',
} as const;
